import App from './components/App';
import { httpClient, rentalManagerHttpClient } from './httpClient';
import { renderClientIndex } from '@zg-rentals/rental-manager-env';
import { setClient } from '@zg-rentals/ts-adproducts-client/client';
import { setClient as setRentalManagerClient } from '@zg-rentals/ts-rental-manager-api-client/client';
import { analytics } from './analytics';

import './index.css';

setClient(httpClient);
setRentalManagerClient(rentalManagerHttpClient);

renderClientIndex({
  app: <App />,
  appName: __APP_NAME__,
  onBootstrapRegister: analytics.initialize,
});

module.hot?.accept();
